// base
import { createSlice } from '@reduxjs/toolkit';
// actions
import { PMT_SLICE_NAME } from '../actions/pmt.action';
// thunks
import {
  createPmt,
  getPmtHistoryList,
  getPmtHistoryListVendor,
  getPmtList
} from '../thunks/pmt.thunk';

// initialState
const initialState = {
  pmtList: [],
  history: [],
  historyTotalMap: undefined,
  historyVendor: [],
  historyVendorTotalMap: undefined,
  pmtInfo: undefined
};

// createSlice
const pmtSlice = createSlice({
  name: PMT_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPmtHistoryList.fulfilled, (state, action) => {
      const res = action.payload;
      state.history = res?.resultList || [];
      state.historyTotalMap = res?.totalMap;
    });

    builder.addCase(getPmtHistoryListVendor.fulfilled, (state, action) => {
      const res = action.payload;
      state.historyVendor = res?.resultList || [];
      state.historyVendorTotalMap = res?.totalMap;
    });

    builder.addCase(getPmtList.fulfilled, (state, action) => {
      const res = action.payload;
      state.pmtList = res?.resultList || [];
    });

    builder.addCase(createPmt.fulfilled, (state, action) => {
      const res = action.payload;
      state.pmtInfo = res?.resultObject;
    });
  }
});

export const pmt = pmtSlice.name;
export const pmtReducer = pmtSlice.reducer;
export const pmtActions = pmtSlice.actions;
export default pmtSlice.reducer;
